<template>
    <div class="max">

        <header v-if="ispc">
            <div class="row">
            <div class="container concenter">
              <img class="headerimg" src="../assets/img/logo1.png" alt="" />
            </div>
            </div>
        </header>
        <section>
            <div class="row">
                 <div v-if="!ispc" class="imglogobox">
                    <img src="../assets/img/logo1.png" alt="">
                </div>
            <div class="container topone disflex" >
                <div class="left">
                    <div>
                        <h4>竞赛精品班</h4>
                        <p>真题疑难讲解，快速提高成绩</p>
                        <span>SSAT |  纽约时报写作竞赛 | 袋鼠数学 | 小托福 | 剑桥英语 | MIT APP编程开发</span>
                    </div>
                    <div>
                        <img src="../assets/img/Aac3.png" alt="">
                        <img src="../assets/img/Aac2.png" alt="">
                    </div>
                </div>
                <div class="right">
                    <div class="forms_submit">
                        <el-form style="width: 100%" label-position="top" :rules="rules" label-width="80px" ref="ruleForm" :model="formLabelAlign" hide-required-asterisk>
                            <el-form-item label="孩子昵称">
                                <el-input v-model="formLabelAlign.child_nickname" placeholder="孩子昵称"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号码" prop="mobile"  class="pcahold">
                                <el-input  oninput="value=value.replace(/\D/gi,'')" v-model="formLabelAlign.mobile" placeholder="请输入您的手机号"  :maxlength="max">
                                    <el-select  ref="select"  v-model="formLabelAlign.country_code" slot="prepend"  :placeholder="$t('Country Code')" @change="changeCode">

                                        <el-option v-for="(item, index) in countries" :label="` ${item.zh} `" :key="index" :value="item.id">
                                            <div class="selectoption">
                                                <span> <img :src="item.flag" alt=""> {{item.zh}} </span>
                                                <span> +{{ item.country_code }}</span>
                                            </div>

                                        </el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="电子邮箱" prop="email">
                                <el-input v-model="formLabelAlign.email" placeholder="example@gmail.com"></el-input>
                            </el-form-item>
                            <el-form-item label="微信号">
                                <el-input v-model="formLabelAlign.wechat_id" placeholder="wechat ID"></el-input>
                            </el-form-item>
                        </el-form>
                        <button @click="submit('ruleForm')">立刻报名</button>
                    </div>
                </div>
            </div>
            </div>
            <img class="imgone" src="../assets/img/Aac4.png" alt="">
            <img class="imgtwo" src="../assets/img/Aac5.png" alt="">
        </section>
        <div class="imgbox">


            <div class="contenrbox">
                <img  class="imggr1" src="../assets/img/Rectangle 9.png" alt="">
                <img class="imggr3" src="../assets/img/Rectangle 11.png" alt="">
                <img class="imggr2" src="../assets/img/Rectangle 10.png" alt="">
                <img class="imggr4" src="../assets/img/Rectangle 12.png" alt="">
            </div>
            <div class="title">
                <img class="imggr5" src="../assets/img/Rectangle 13.png" alt="">
            </div>
        </div>
        <div class="imgthree">
           <img class="" src="../assets/img/Aac6.png" alt="">
        </div>

        <footer>

            <!-- <div class="row"> -->
                <div class="foottop">
                    <div class="foottopitem">
                        <div class="itemdiv">
                            <div class="itemleft">
                                <img src="../assets/img/Aacteacher1.png" alt="">
                                <p>Michelle 老师 </p>
                                <span><p>纽约时报写作，</p><p>SSAT英语，小托福</p> </span>
                            </div>
                            <div class="itemright li3">
                                <ul>
                                    <li>美国俄州公立学校在职名师，8年英语教学经验</li>
                                    <li>精通英语语法发音教学，英语阅读解题技巧，帮助学生快速提分</li>
                                    <li>深耕美国小托福考试多年，帮助上百名学生提高小托福成绩</li>
                                </ul>
                            </div>
                        </div>
                        <div class="itemdiv" >
                            <div class="itemleft">
                                <img src="../assets/img/Aacteacher2.png" alt="">
                                <p>Regan 老师 </p>
                                <span>袋鼠奥数，SSAT数学</span>
                            </div>
                            <div class="itemright">
                                <ul>
                                    <li>毕业于美国德州 A&M 大学应用数学专业</li>
                                    <li>熟悉往年真题解析出题思路与考点</li>
                                    <li>学生在AMC8竞赛中 入围全球Top 5%</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="foottopitem">
                        <div class="itemdiv">
                            <div class="itemleft">
                                <img src="../assets/img/Aacteacher3.png" alt="">
                                <p>Brooklynn 老师  </p>
                                <span><p>剑桥英语，小托福，</p> <p>SSAT英语</p> </span>
                            </div>
                            <div class="itemright li4">
                                <ul>
                                    <li>田纳西州立大学儿童教育学学士学位</li>
                                    <li>4年教学经验，持证青少年教育专家</li>
                                    <li>小托福，剑桥英语名师，帮助上百名学生提高成绩</li>
                                    <li>善于根据学生特点来制定合适的教学方法</li>
                                </ul>
                            </div>
                        </div>
                        <div class="itemdiv li5">
                            <div class="itemleft">
                                <img src="../assets/img/Aacteacher4.png" alt="">
                                <p>Brenda 老师</p>
                                <span><p>剑桥英语，SSAT英语，</p><p>英语写作</p> </span>
                            </div>
                            <div class="itemright ">
                                <ul>
                                    <li>4年教学经验，授课超4000节，授课学生超过1700个</li>
                                    <li>英语、西语双母语，专业纠正学生口音、语法、声调等；</li>
                                    <li>善于在小班中关注每个学生的学习进度</li>
                                    <li>擅长解析英语竞赛命题中的逻辑语答题技巧</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="foottopitem">
                        <div class="itemdiv">
                            <div class="itemleft">
                                <img src="../assets/img/Aacteacher5.png" alt="">
                                <p>Annah 老师  </p>
                                <span>MIT APP编程开发</span>
                            </div>
                            <div class="itemright li6">
                                <ul>
                                    <li>信息工程硕士学位，4年编程经历</li>
                                    <li>精通6种编程语言，在职软件开发工程师</li>
                                    <li class="">数据管理与网络开发专家证书，IT课程老师</li>
                                    <li>擅长用创新和实用的教学法帮助学生理解编程语言</li>
                                </ul>
                            </div>
                        </div>
                        <div class="itemdiv">
                            <div class="itemleft">
                                <img src="../assets/img/Aacteacher6.png" alt="">
                                <p>Megan 老师</p>
                                <span>袋鼠奥数，SSAT数学</span>
                            </div>
                            <div class="itemright">
                                <ul>
                                    <li>肯塔基大学教育学专业学士学位</li>
                                    <li>6年教学经验，肯塔基公立学校在职老师</li>
                                    <li>善于拆解复杂数学难题，高效梳理数理概念</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dispsdfsd">
                     <div class="footbottom" v-if="ispc">
                        <img class="Aac1" src="../assets/img/Aaclogomax1.png" alt="">
                        <img class="Aac2"  src="../assets/img/Aaclogomax2.png" alt="">
                        <img class="Aac3"  src="../assets/img/Aaclogomax3.png" alt="">
                        <img class="Aac4"  src="../assets/img/Aaclogomax4.png" alt="">
                    </div>
                    <div class="footbottom" v-else>
                        <img src="../assets/img/Aaclogo1.png" alt="">
                        <img src="../assets/img/Aaclogo2.png" alt="">
                        <img src="../assets/img/Aaclogo3.png" alt="">
                        <img src="../assets/img/Aaclogo4.png" alt="">
                    </div>
                    <div class="footbottom footbottom-last">
                        <img class="Aac5" src="../assets/img/Aaclogo5.png" alt="">
                        <img class="Aac6" src="../assets/img/Aaclogo6.png" alt="">
                    </div>
                </div>

            <!-- </div> -->
        </footer>



        <div class="interbox" v-if="btnFlag"  @click="toTop">点击报名</div>
        <!-- <div class="interbox" v-if="btnFlag"  @click="handleLogin" > {{$t('Claim FREE Package')}} </div> -->
        <div v-show="dialogVisible" class="show-captcha"  @click="closebg">
        <div  class="show-captcha-div" @click.stop>
                <div ref="captcha"></div>
        </div>
        </div>
    </div>
</template>

<script>
import { joinUser, getCountries, recordClick, getImgCode} from '../api';
import { loadingData } from '../utils';
import { setStore, keys } from '../store';
import  i18n  from '../locales/i18n';
import locale from 'element-ui/lib/locale';
export default {
    data() {
        /* var checkPhone = (rule, value, callback) => {
            const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
            if (this.formLabelAlign.country_code == '') {
                return callback(new Error('区号不能为空'));
            }
            if (!value) {
                return callback(new Error('电话号码不能为空'));
            }
            setTimeout(() => {
                // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
                // 所以在前面加了一个+实现隐式转换

                if (!Number.isInteger(+value)) {
                    callback(new Error('请输入数字值'));
                } else {
                    if (phoneReg.test(value)) {
                        callback();
                    } else {
                        callback(new Error('电话号码格式不正确'));
                    }
                }
            }, 100);
        }; */
        var checkEmail = (rule, value, callback) => {
            const mailReg = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/;
            if (!value) {
                return callback(new Error('邮箱不能为空'));
            }
            setTimeout(() => {
                if (mailReg.test(value)) {
                    callback();
                } else {
                    callback(new Error('请输入正确的邮箱格式'));
                }
            }, 100);
        };

        return {
            formLabelAlign: {
                child_nickname: '',
                mobile: '',
                email: '',
                wechat_id: '',
                country_code: '',
                code:''
            },
            comment: {
                index: 0,
                count: 4,
            },
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { min: 10, message: '手机号码格式不对', trigger: 'blur' },
                ],
                email: [{required: true, validator: checkEmail, trigger: 'blur' }],
            },
            countries: [],
            max:10,
            min:10,
            btnFlag:false,
            flag:'',
            dialogVisible: false,
            input:'',
            screenWidth:'',
            messagecode:false
        };
    },
    mounted() {
        loadingData(async () => {
            let result = await getCountries({});
            this.countries = result.map((item) => {
                return { id: item.id,zh:item.name_zh, name: '+'+item.country_code+' '+item.name_zh, country_code: item.country_code,flag:item.flag };
            });
            // this.formLabelAlign.country_code = this.countries[0].id
            // this.formLabelAlign.code = this.countries[0].country_code
        });
        var that=this
        that.screenWidth  =document.body.clientWidth ||window.screenWidth;
        window.addEventListener("resize", function() {
                        return(() => {
                         that.screenWidth  =document.body.clientWidth ||window.screenWidth;
                            //  console.log(that.screenWidth)
                        })();
                    });
        window.addEventListener("scroll", this.handleScroll);
        var tag="<span>"+this.formLabelAlign.code+"</span> ";
        var img="<img >"
        this.$refs['select'].$el.children[0].children[0].insertAdjacentHTML("beforeBegin",img);
              this.$refs['select'].$el.children[0].children[0].setAttribute(
            'style',
            'display:none;'
          )
        this.$refs['select'].$el.children[0].children[2].children[0].insertAdjacentHTML("beforeBegin",tag);
       //生成验证码--------------
       var self = this;
		    var options = {
		      element: this.$refs.captcha,
		      captchaId: "2e3422055bf14588a401899f1d8b25b6",
		      width: "320px",
             mode: 'embed',
              apiVersion: 2,
               lang :i18n.locale=='en'?'en':'zh-CN',
              onVerify:(err,data)=>{   //验证之后的回调函数,err验证失败才有值
                   if (err){
                    this.input=''
                    return
                  }
                  if(data){
                      this.input=data.validate
                      this.dialogVisible=false
                      this.submit('ruleForm')
                       self.instance && self.instance.refresh();
                    //    console.log(data.validate)
                  }
              }
		    };
		    initNECaptcha(options, function onLoad(instance) { //初始化成功
		    //   console.log(instance);
		      self.instance = instance;
		    },
            function onerror (err) { //初始化失败
                console.log(err)
            }
            );
		    this.$refs.popups.addEventListener("click", function() {
		      self.instance && self.instance.refresh();
		    });
      //-----------
    },
    computed: {
        ispc() {
            return window.innerWidth > 768 ? true : false;
        },
    },
    watch: {
        ispc(val) {
            window.onload();
        },
    },
    methods: {
        //关闭遮罩
         closebg(){
        this.dialogVisible=false
        },
        handleScroll(){
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 700) {
              this.btnFlag = true
            } else {
               this.btnFlag = false
            }
        },
      changeCode(){
           this.countries.map((item) => {
            if(this.formLabelAlign.country_code == item.id){
                this.formLabelAlign.code = item.country_code
                 this.flag=item.flag
            }
        });
        if(this.formLabelAlign.code=='86'){
            if(this.formLabelAlign.mobile.length>11){
                this.formLabelAlign.mobile = ''
            }
          this.max = 11
          this.min = 11
          this.rules.mobile[1]={min: this.min, message: '手机号码格式不对', trigger: 'blur'}
        //   this.rules.mobile[1].min=1
        }else if(this.formLabelAlign.code=='1'){
          if(this.formLabelAlign.mobile.length>10){
            this.formLabelAlign.mobile = ''
          }
          this.max = 10
          this.min = 10
          this.rules.mobile[1]={min: this.min, message: '手机号码格式不对', trigger: 'blur'}
        //   this.rules.mobile[1].min=1
        }else{
            this.max=15
            this.min = 6
            this.rules.mobile[1]={min: this.min, message: '手机号码格式不对', trigger: 'blur'}
            // this.rules.mobile[1].min=6
        }
            this.$refs['select'].$el.children[0].children[1].setAttribute(
            'style',
            // 'background:url('+ this.flag +') no-repeat;background-size: 21px 15px;background-position: 12px 13px;padding: 0 52px  0   49px; color: #111827;font-family: "Inter";font-weight: 500;font-size: 14px;'
            'padding: 0 0px 0 40px;'
          )
        this.$refs['select'].$el.children[0].children[0].src=this.flag;
        this.$refs['select'].$el.children[0].children[0].setAttribute(
            'style',
            'display:block;'
          )
          this.$refs['select'].$el.children[0].children[2].children[0].innerHTML="+"+this.formLabelAlign.code;
      },
        async submit(ruleForm) {
            await loadingData(async () => {
                try {
                    let form = {
                        mobile: this.formLabelAlign.mobile,
                        email: this.formLabelAlign.email,
                        country_code: this.formLabelAlign.code,
                        child_nickname: this.formLabelAlign.child_nickname,
                        wechat_id: this.formLabelAlign.wechat_id,
                        landingpage_id: 15,
                        captcha:this.input,
                        ...this.$route.query,
                    };

                    this.$refs[ruleForm].validate(async (valid) => {
                        if (valid) {
                            if(!this.formLabelAlign.country_code){
                                alert(i18n.t('Please select your country code'))
                                return false
                            }
                            if(this.input==''){
                                this.dialogVisible=true
                                return
                            }else{
                                this.input=''
                            let userInfo = await joinUser(form);

                            setStore(keys.userInfo, userInfo);
                            // if (userInfo.is_register){
                            // await recordClick(2,userInfo.user_sn);
                            // }

                            await recordClick(1, userInfo.user_sn, 'landingpage-id:15');
                            if (userInfo.name) this.$router.push({ path: '/salecard',query:{invite_code:userInfo.invite_code} });
                            // setTimeout(() => {
                            //     if (userInfo.name) this.$router.push({ path: '/salecard',query:{invite_code:userInfo.invite_code} });
                            // }, 1000);
                            }
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                } catch (error) {
                    this.status = false;
                }
            });
        },
        commentClick(value) {
            console.log(value);
            let nextIndex = this.comment.index + value;
            if (nextIndex < 0) return;
            if (nextIndex + 3 > this.comment.count) return;

            this.$refs.overContainer.scrollLeft = nextIndex * 330;
            this.comment.index = nextIndex;
        },

        toTop() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                if(window.innerWidth>763&&top <= 100){
                    clearInterval(timeTop);
                }
                else if(window.innerWidth<763&&top <= 350){
                     clearInterval(timeTop);
                }

                // if (top <= 250) {
                //     clearInterval(timeTop);
                // }
            }, 10);
            // document.body.scrollTop = document.documentElement.scrollTop =250;
        },
    },
    components: {},
};
</script>

<style scoped lang='less'>
.captcha-botton{
  width: 90%;
  height: 40px;
   border-radius:6px;
   cursor: pointer;
       background-color: #409eff;
    border-color: #409eff;
    color: #fff;
    border: none;
}
//图片滑动验证码样式
.show-captcha{
   position: fixed;
   display: flex;
   justify-content:center;
   align-items:center;
   top: 0%;
   left: 0%;
   right: 0;
   bottom: 0;
   background-color: rgba(0, 0, 0, 0.3);
   z-index: 99999999999;
   .show-captcha-div{
       display: flex;
       justify-content : center;
       align-items:center;
       flex-direction:column;
       width: 350px;
       height: 350px;
       background: #fff;
       padding: 5px 5px;
       position: relative;
       div{
         text-align: center;
         box-sizing: border-box;
       }
       button{
          //  position: absolute;
          //  bottom: 10px;
           width: 80%;
           margin-top: 20px;
          //  left: 10%;
       }

   }
}

/deep/.el-select .el-input {
    img{
        width: 17px;
        position: absolute;
        left: 12px;
        bottom: 14px;
    }
}

.selectoption{
        width: 370px;
        display: flex;
        justify-content:space-between;
        img{
            width: 15px;
            margin-right: 16px;
        }
        span{
            display: flex;
            align-items: center;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;

            color: #111827;
        }
    }

/deep/.el-select .el-input .el-input__icon{
    width: 7px;
    font-size: 9px;
    padding-right: 7px;
}
    /deep/.el-input__suffix{
        display: flex;
        align-items:center;
        margin: auto;
        span:nth-child(1){
            display: block;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            margin: auto;
            padding-left: 5px;
            color: #111827;
            // width: 30px;
                }

    }
body {
    overflow-x: hidden;
    box-sizing: border-box;
    // font-family: 'Muli';
}
h1,h3 {
    margin: 0;
    font-weight: normal;
}
@media screen and (min-width: 768px) {
    .max{
        background: #ffffff;
        min-width: 1440px;
        position: relative;
    }
    /deep/.el-select{
        width: 128px !important;
    }
    .topone{
        padding:0 124px;width:1440px;box-sizing: border-box;
    }
    .interbox{
       cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: linear-gradient(94.75deg, #FF6F1E 46.16%, #F9A849 91.27%);
      border-radius: 25px;
      position: fixed;
      bottom: 72px;
     height: 48px;
     width: 573px;
     z-index: 999;
     left: calc(50% - 573px/2);;
      font-family: MuliBold;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    font-feature-settings: 'salt' on;
    color: #FFFFFF;
    filter: drop-shadow(0px 4px 26.64px rgba(0, 0, 0, 0.25));
  }
  .row{
    height:100%;
  }
  .container {
    font-size: 14px;
    font-family: 'Muli';
    // max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-between;
  }
  .concenter{
      align-items: center;
  }
    header {
      display: block;
        box-sizing: border-box;
        height: 88px;
        padding-left: 112px;
        > div {
            span {
                margin-left: 24px;
                a{
                  font-size: 16px;
                  color: #111827;
                  font-family: MuliSemiBold;
                  font-weight: 600;
                }
            }
        }
    }

    section {
        position: relative;

        box-sizing: border-box;
        background: #0085F2;

        background-size: cover;
        height: 947px;
        .mask {
            position: absolute;
            top: 0;
            left: 0;

            right: 0;
            bottom: 0;
            display: flex;

            // background: rgba(232, 49, 85, 0.4);
        }
            .imgone{
                position: absolute;
                bottom: 0;
                left:0;
                right: 0;
                width: 100%;
            }
            .imgtwo{
                position: absolute;
                bottom: 0;
                left:0;
                right: 0;
                width: 100%;
            }
            .left {
                // flex:4;
                div:nth-child(1) {
                    width:  655px;
                    height: 297px;
                    border: 3px solid #FFFFFF;
                    margin:125px 0 0;
                    position: relative;
                    h4{
                        font-family: 'MuliBold';
                        width: 530px;
                        font-style: normal;
                        font-weight: 700;
                        font-size: 96px;
                        line-height: 80px;
                        text-align: center;
                        letter-spacing: -0.02em;
                        color: #FFFFFF;
                        margin:0;
                        top: -48px;
                        left: calc(50% - 260px);
                        position: absolute;
                        background: #0085F2;
                    }
                    p{
                        margin: 65px auto 21px;
                        font-family: 'MuliSemiBold';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 40px;
                        line-height: 80px;
                        text-align: center;
                        letter-spacing: -0.02em;
                        color: #FFFFFF;
                    }
                    span{
                        background: #FFFFFF;
                        padding: 0 14px;
                        box-sizing: border-box;
                        border-radius: 52px;
                        width: 570px;
                        height: 76px;
                        font-family: 'MuliSemiBold';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 20px;
                        line-height: 28px;
                        text-align: center;
                        font-feature-settings: 'salt' on;
                        color: #0085F2;
                        margin: 0 auto;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }

                div:nth-child(2) {
                    position: relative;
                    img{
                        position: absolute;
                    }
                    img:nth-child(1){
                        top: -30px;
                        left: 368px;
                    }
                    img:nth-child(2){
                        top: 68px;
                        left: 60px;
                        z-index: 9999;
                    }
                }
            }
            .right {
                // flex: 3;
                // margin-left: 5%;
                // display: flex;
                // flex-direction: column;
                // align-items: center;
                .forms_submit {
                    width:458px;
                    margin:90px 0 0;
                    background: #FFFFFF;
                    box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.1), 0px 4px 6px -4px rgba(16, 24, 40, 0.1);
                    border-radius: 12px;
                    box-sizing: border-box;
                    padding:42px 24px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    // justify-content: space-between;
                    /deep/ .el-form-item {
                        font-family: Muli;
                        font-weight: 400;
                        margin-bottom: 32px;
                        .el-form-item__label{
                          font-family: 'MuliSemiBold';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 14px;
                        line-height: 20px;
                        font-feature-settings: 'salt' on;
                        color: #111827;
                        flex: none;
                        order: 0;
                        align-self: stretch;
                        flex-grow: 0;
                        margin-bottom: 4px;
                        }
                        .el-form-item__content{
                          line-height: 44px;
                          .el-input-group{
                            .el-input__inner{
                                    border-radius:0 6px 6px 0;
                                    font-family: Muli;
                                    font-weight: 400;
                            }
                          }
                          .el-input-group__prepend{
                            background: none;
                            border:none;
                            .el-input__inner{
                                border-radius:6px 0 0 6px;
                                font-family: Muli;
                            }
                          }
                          .el-input__inner{
                            height: 44px;
                            // background: #FFFFFF;
                              /* Neutral/300 */
                              font-family: 'Muli';
                            border: 1px solid #D1D5DB;
                            box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                            border-radius: 6px;
                               &::placeholder {
                                 color: #9CA3AF;
                                  font-size: 16px;
                                 font-family: 'Muli';
                              }
                          }
                        }
                    }
                    .toplog {
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        letter-spacing: -0.02em;
                        font-weight: 800;
                        font-family: MuliBold;
                        margin: 0 auto 24px;
                        h1 {
                            text-align: center;
                            letter-spacing: -0.02em;
                            color: #191919;
                            font-size: 42px;
                            font-weight: 800;
                            margin: 0;
                            padding: 0;
                            line-height: 40px;
                        }
                        .subTitle {
                            font-size: 24px;
                            letter-spacing: -0.02em;
                        }
                        .subBreif{
                          font-size: 18px;
                          display: block;
                          margin-top: 5px;
                           font-weight: 400;
                        font-family: Muli;

                        }
                    }
                    .buttonclass{
                        border-radius: 25px;
                        width: 400px;
                        text-align: center;
                    }
                    button {
                        width: 376px;
                        height: 48px;
                        border: none;
                        background: linear-gradient(94.75deg, #FF6F1E 46.16%, #F9A849 91.27%);
                        border-radius: 25px;
                        font-family: 'MuliBold';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 18px;
                        line-height: 28px;
                        text-align: center;
                        font-feature-settings: 'salt' on;
                        color: #FFFFFF;
                    }
                }
            }
    }
    .bodypink {
        background: #f7f5fa;
        padding: 139px 0 0 0;
        text-align: center;
        // position: relative;
        overflow: hidden;
        .four {
            // padding-left: 20%;
            width: 100%;
            margin: 0 auto;
            border: 4px solid #ff5979;
            box-sizing: border-box;
            border-radius: 16px;
            height: 400px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            position: relative;
            img{
              position: absolute;
              top:-65px;
              left:50%;
              margin-left:-260px;
            z-index:21;
            }
            .title-1{
              position: absolute;
              top:-55px;
              left:50%;
              margin-left:-111px;
                z-index:22;
                font-size: 32px;
                color: #FFFFFF;
                font-weight: 700;
                font-family:MuliBold ;
            }
             .flexsum{
                display: flex;
                margin-top: 0px;
            }
            .flex-line{

                    justify-content: space-around;
                    align-items: center;
                    width: 380px;
                    margin: 0px 10px;
                    margin-top: 38px;

                    flex-direction: column;
                    justify-content: start;
                    align-items: flex-start;

                    span {
                        display: block;
                        font-style: normal;

                        text-align: center;
                        margin: 0px auto;
                    }

                    span:first-child {
                        color: #FF5979;
                        font-weight: 700;
                        font-family: MuliBold;
                        font-size: 26px;
                        line-height: 48px;
                        width: 290px;
                        margin-bottom: 20px;

                    }
                    p{
                        margin: 0;
                        height: 48px;
                    }

                    span:last-child {
                        font-weight: 400;
                        font-size: 20px;
                        line-height: 36px;
                        width: 370px;



                    }

            }


            > div:nth-child(odd) {
            }
        }


        .pinkTwo {
            margin-top: 21px;
            position: relative;
            display: flex;
            .two_tit {
              width:500px;
                margin-top: 50px;
                display: flex;
                flex-direction: column;
                // max-width: 470px;
                // padding-left: 120px;
                text-align: start;

                span:nth-child(1) {
                    font-size: 34px;
                    color: black;
                    margin-top: 24px;
                    font-family: MuliBold;
                    font-weight: 700;
                }
                span:nth-child(2) {
                  margin-top:17px;
                    font-size: 17px;
                    color: #374151;
                    line-height: 28px;
                    font-weight: 400;
                }
            }
            .tabs{
              display: none;
            }
            .piclist {
              flex:1;
                  margin-right: -135px;
                display: flex;
                flex-wrap: wrap;
                /*   justify-content: flex-end; */
                /* margin-left: 60px; */
                > div {
                    margin: 0 0 48px 65px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    position: relative;
                    span {
                        margin-top: 10px;
                        font-weight: 400;
                    }
                    .oneimg1{
                        width: 80px;
                        height: 80px;
                    }

                }

                div:nth-child(5),
                div:nth-child(10),
                div:nth-child(15) {
                    margin-right: 0px;
                }
            }
        }
    }

    .bodyred {
      position: relative;
      .img1{
        width:470px;
        height:540px;
        position: absolute;
        top:0;
        left:0;
        z-index:10;
      }
      .img2{
        width:273px;
        height:362px;
        position: absolute;
        top:0;
        left:0;
        z-index:11;
      }
      .img3{
        width:430px;
        height:910px;
        position: absolute;
        bottom:0;
        right:0;
        z-index:11;
      }
    }

    .youshiBox{
        width:100%;
        height: 100%;
        z-index:13;
        .title-2 p{
            position: absolute;
            top: -20px;
            left: 50%;
            margin-left: -111px;
            z-index: 13;
            font-size: 32px;
            color: #000000;
            font-weight: 700;
            font-family: MuliBold;
        }
        .THRbox {
            margin-top: 84px;
            display: flex;
            justify-content: center;
            .whitebox {
                // margin: 0 20px;
                width: 384px;
                height: 132px;
                padding: 0 20px 20px;
                flex:1;
                margin-right:32px;
                background: #FFFFFF;
                /* Drop shadow/Small */

                box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px -1px rgba(16, 24, 40, 0.1);
                border-radius: 6px;


                // width: 30vw;
                /*  width: 384px; */
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                span:first-child {
                    color: #ff5979;
                    font-size: 28px;
                    font-weight: 700;
                    font-family: MuliBold;

                }
                span {
                    font-size: 20px;
                    color: #6B7280;
                    font-weight: 400;

                }
            }
        }
    }

    .jiangpai {
        position: absolute;
        background: url('../assets/img/Framejiangpai.png') no-repeat;
        top: 420px;
        left: 0;
        width: 113px;
        height: 140px;
        display: block;
    }

    .iphone {
        /* margin: 0 auto; */

        /* width: 943.36px;
        height: 484.3px; */
        width: 942px;
        height: 484px;
        border-radius: 47px;
        background-color: #fff;
        transform: rotate(-10.16deg);
        margin-top: 60px;
        background: #FFFFFF;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);

        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin:184px auto 0;
        img {
            /*  position: absolute; */
            width: 900px;
            // height: 402.09px;
            // margin-top: 1vh;
            /*  width: 90%;
            height: 90%; */
            /*  left: 13px;
            top: -38px; */
            transform: rotate(10.16deg);
            /* transform: rotate(10.16deg); */
        }
    }

    .guide {
        position: absolute;
        /*  background: url('../assets/img/Groupguird.png') no-repeat; */
        top: 850px;
        z-index: 13;
        // left: 100%;
        right: 0px;
        width: 315.97px;
        height: 311.54px;

    }

    .appCircleRIG{
      display: none;
    }
    .bgWhite {
      background: #F7F5FA;
      .whiteBg{
        display: block;
        position: relative;
        .cerebrumAPP {
            z-index: 1;
            position: absolute;
            background: url('../assets/img/Framecere.png') no-repeat;
            top: -75px;
            right: 249px;
            width: 126px;
            height: 123px;
        }
        > img {
            margin: 50px auto 30px;
        }
      }
        background: #f7f5fa;
        text-align: center;
        /*    padding-bottom: 185px; */
        #mien {
            padding: 120px 0 90px 0;
            font-size: 32px;
            font-weight: 700;
            font-family: MuliBold;
        }
        .videoStyle {
            width: 100%;

            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            > div {
                flex-basis: 40vw;
                min-height: 200px;
                background-color: #fff;
                margin-bottom: 36px;
            }
        }

		.video_box{
			display: flex;
			flex-wrap:wrap;
      justify-content: space-evenly;
			.video_info{
				height: 251px;
				width: 570px;
				// margin-right: 60px;
				margin-bottom:60px;
				&:nth-child(2n){
					margin-right:0;
				}
			}
		}
        .swiperfor {
            margin-top: 130px;
            text-align: center;
            margin-bottom:60px;
            font-weight: 700;
            font-family: MuliBold;
            > div:nth-child(1) {
                font-size: 14px;
                color: #ff5979;

            }
            > div:nth-child(2) {
                font-size: 40px;
                color: #111827;
                margin-top:16px;
            }
        }
        .btn_lq {
            width: 410px;
            height: 47px;
            border-radius: 37px;
            background: #ff5979;
            color: white;
            margin: 70px auto 0;
            font-size: 18px;
            justify-content: center;
            align-items: center;
            display: flex;
        }
    }
    .star-item {
        width: 210px;
    }
    .star-list {
        .over-list {
            overflow: hidden;
            width: 820px;
            white-space: nowrap;
            scroll-behavior: smooth;
            .arrow-left,.allow-right{}
            > .star-item {
                display: inline-block !important;
                vertical-align: top;
                white-space: normal;
                margin-left: 30px !important;
                margin-right: 30px !important;

                > * {
                    display: block;
                }
                .star-desc{
                    font-family: 'Poppins';
                    color: #0B1D33;
                }
                .star-sub{
                    color: rgba(11, 29, 51, 0.6);
                }
            }
        }
    }
    .star-left {
        width: 190px;
        span{
            font-family: 'Poppins';
            font-weight: 400;
        }
    }
    .star-container {
        // margin-left: 10vw;
        // width: 70vw;
        width: 1010px;
         display: flex;
         margin: 0 auto;
        justify-content: center;
        .star-left {
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;

            label {
                font-size: 21.654px;
                line-height: 100%;

                text-align: center;

                color: #000000;
            }

            .star-img-big {
                width: 190.07px;
                height: 39.7px;
            }
        }
         .start-content{
             display: flex;
             margin-left:60px;
             .info-feed{

                box-shadow: 12px 8px 33px rgba(0, 0, 0, 8%);
                height: 179px;
                width: 201px;
                padding: 19px 13px;
                margin-right:40px;
                &:nth-child(3){
                    margin-right: 0;
                }
                h6 {
                    color: #000;
                    // display: block;
                    // width: 183px;
                    font-size: 20px;
                    z-index: 100040;
                    line-height: 1.1;
                    letter-spacing: 0;
                    text-align: left;
                    text-align-last: left;
                    font-style: normal;
                    display: block;
                    margin: 0 11px;
                    margin-bottom: 13px;
                    font-family: "times new roman";
                    font-weight: bold;
                }
                p {
                    color: #000;
                    display: block;
                    // width: 177px;
                    font-size: 14px;
                    line-height: 1.4;
                    letter-spacing: 0;
                    font-style: normal;
                    text-align: left;
                    text-align-last: left;
                    margin: 0 8px;
                    font-family: "open sans";
                }
                img {
                    height: 29px;
                    width: 169px;
                    margin-bottom: 6px;
                }
             }
         }
    }
     .imgthree{
            position: absolute;
            right: 0px;
            top:1130px;
            overflow: hidden;
            img{
                margin-right: -40px;
            }
        }
    footer {
        // background: #FFFFFF;
        height: 1300px;
        text-align: center;
        position: relative;
        .foottop{
            z-index: 99999;
            margin:128px auto 102px;
            padding:0 18px;
             width: 1440px;
             box-sizing: border-box;
            // display: flex;
            // flex-direction:column;
            .foottopitem{
                width: 100%;
                // height: 294px;
                display: flex;
                flex: 1;
                justify-content:space-between;
               .itemdiv{
                  box-shadow: -23px 15px 33px #F4F2F2;
                  width: 680px;
                  height: 295px;
                  display: flex;
                //   padding: 23px 0;
                  box-sizing: content-box;
                  background: #FFFFFF;
                  border-radius: 10px;
                  .itemright{
                      width: calc(100% - 340px);
                      padding: 0 7px 0 17px;
                      ul{
                          margin: 0;
                          padding-left: 20px;
                          li{
                              font-family: 'Muli';
                                font-style: normal;
                                font-weight: 400;
                                font-size: 20px;
                                line-height: 39px;
                                font-feature-settings: 'salt' on;
                                color: #000000;
                                opacity: 0.85;
                                text-align: left;
                          }
                      }
                  }
                  .itemleft{
                      width: 282px;
                      border-right: 1px solid rgb(229, 229, 229);
                      img{
                          margin-top: 10px;
                      }
                      p{
                          margin: 14px 0 6px;
                          font-family: 'MuliBold';
                            font-style: normal;
                            font-weight: 700;
                            font-size: 34px;
                            // line-height: 24px;
                            text-align: center;
                            font-feature-settings: 'salt' on;
                            color: #111827;
                      }
                      span{
                          font-family: 'MuliBold';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 20px;
                        line-height: 24px;
                        text-align: center;
                        font-feature-settings: 'salt' on;
                        color: #0085F2;
                        display: block;
                        width: 220px;
                        margin: 0 auto;
                        p{
                            font-family: 'MuliBold';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 20px;
                        line-height: 24px;
                        text-align: center;
                        font-feature-settings: 'salt' on;
                        color: #0085F2;
                        display: block;
                        margin: 0;
                        }
                      }
                  }
                }
                .li5{
                    .itemright{
                         width: calc(100% - 320px);
                    }
                }


            }
            .foottopitem+.foottopitem{
                margin-top:39px;
            }
        }
        .dispsdfsd{
            padding: 0 0 50px;
        }
        .footbottom{
            display: flex;
            margin:0 auto  24px;
            justify-content:space-around;
            width: 1400px;
            .Aac1{
                width: 212px;
            }
            .Aac2{
               width: 315px;
            }
            .Aac3{
                width: 373px;
            }
            .Aac4{
                width: 315px;
            }
            .Aac5{
                width: 219px;
            }
            .Aac6{
                width: 246px;
            }
        }
        .footbottom-last{
            margin: 0 auto  46px;
            justify-content: center;
            img+img{
                margin-left: 32px;
            }
        }
    }

    .imgbox{
        display: flex;
        width: 1180px;
        margin: 0 auto;
        justify-content: center;
        position: relative;
        z-index: 999;
        div{
            display: flex;
            align-items: center;
        }
        .imggr1{
            width: 189px;
            // height: 122px;
            margin-right: 32px;
        }
        .imggr2{
            width: 213px;
            // height: 108px;
            margin-right: 32px;
        }
        .imggr3{
            width: 242px;
            // height: 122px;
            margin-right: 32px;
        }
        .imggr4{
            width: 213px;
            // height: 122px;
            margin-right: 32px;
        }
        .imggr5{
            width: 236px;
            // height: 122px;
        }
    }
}
@media screen and (max-width: 767px) {
    .footbottom{
        img{
            width: 100%;
        }
    }
    .max{
        width: 100vw;
        overflow: hidden;
    }
    /deep/.el-select{
        width: 126px !important;
    }
    /deep/.el-input__suffix{
        right: 1px;
        .el-input__suffix-inner{
            margin-right: 3px;
        }
    }
    .selectoption{
        width: 268px;
        }
    .imgone{
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .imgtwo{
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        bottom: 0;
    }
   .pcahold /deep/.el-input__inner{
        padding: 0 0 0 10px;
    }
//验证码插件弹图位置----------------
    /deep/ .yidun_intellisense--light .yidun_classic-container{
       bottom: 0;
       top: auto;
    }
   /deep/ .yidun_popup.yidun_popup--light .yidun_modal{
       bottom: 0;
       top: auto;
       left: 0;
       width: 100%;
       position: absolute;
    }
//--------------------------------------------
    /deep/ .el-scrollbar{
        min-width: 320px;
    }
  .interbox{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: linear-gradient(94.75deg, #FF6F1E 46.16%, #F9A849 91.27%);
      border-radius: 25px;
      position: fixed;
      bottom: 56px;
     height: 48px;
     width: 376px;
     z-index: 999;
     left: calc(50% - 376px/2);
     color: #FFFFFF;
     font-family: 'MuliBold';
    font-style: normal;
     font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    filter: drop-shadow(0px 4px 26.64px rgba(0, 0, 0, 0.25));
  }
  .row{
    height:100%;
  }
  .container {
    font-size: 14px;
    font-family: 'Muli';
    width: 100vw;
    height: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: center;
  }
    header{
        display: none;
    }
    section {
        width: 100vw;
        background: #0085F2;
        position: relative;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        background-size: cover;
        height: 730px;
        .mask {
            position: absolute;
            top: 0;
            left: 0;

            right: 0;
            bottom: 0;
            background: rgba(232, 49, 85, 0.4);
        }
            .leftBTM {
                background: url('../assets/img/Vector.png') no-repeat;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100vw;
                height: 201px;
                background-size: cover;
            }

            .left {
                // min-width: 428px;
                box-sizing:border-box;
                margin: 23px 12px 22px;
                display: flex;
                // padding:0 12px;
                div:nth-child(1) {
                    margin: 0 auto;
                    border: 2px solid #FFFFFF;
                    height: 152px;
                    position: relative;
                    // width: 100%;
                    width: 352px;
                    h4 {
                        font-family: 'MuliBold';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 40px;
                        // line-height: 69px;
                        text-align: center;
                        letter-spacing: -0.02em;
                        color: #FFFFFF;
                        margin: 0;
                        position: absolute;
                        top:-35.5px;
                        width: 230px;
                        left:calc(50% - 115px);
                        background: #0085F2;
                    }
                    p{
                        margin: 18px 0 0;
                        font-family: 'MuliSemiBold';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 24px;
                        line-height: 60px;
                        text-align: center;
                        letter-spacing: -0.02em;
                        color: #FFFFFF;
                    }
                    span{
                        background: #FFFFFF;
                        padding: 0 10px;
                        border-radius: 29px;
                        display: block;
                        height: 43px;
                        width: 294px;
                        text-align: center;
                        line-height: 20px;
                        margin: 0 auto;
                        font-family: 'MuliSemiBold';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 14px;
                        text-align: center;
                        font-feature-settings: 'salt' on;
                        color: #0085F2;

                    }
                }

                div:nth-child(2) {
                    display: none;
                }
            }
            .right {
                display: flex;
                flex-direction: column;
                align-items: center;
                .forms_submit {
                  // position: absolute;
                  // top:-50px;
                    /deep/.el-form{
                      .el-form-item {
                        font-weight: 400;
                        margin-bottom: 12px;
                        .el-form-item__label{
                          font-family: 'Muli';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 20px;
                        font-feature-settings: 'salt' on;
                        color: #111827;
                        margin-bottom: 4px;
                        }
                        .el-form-item__content{
                          line-height: 44px;
                          .el-input-group{
                            .el-input__inner{
                                    border-radius:0 6px 6px 0;
                                    font-family: Muli;
                            }
                          }
                          .el-input-group__prepend{
                            background: none;
                            border:none;
                            .el-input__inner{
                                border-radius:6px 0 0 6px;
                                font-family: Muli;
                            }
                          }
                          .el-input__inner{
                            font-family: 'Muli';
                            height: 44px;
                                border: 1px solid #D1D5DB;
                                box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                                border-radius: 6px;

                               &::placeholder {
                                 color: #9CA3AF;
                                  font-size: 16px;
                                  font-family: Muli;
                              }
                          }
                        }
                      }

                    }
                    z-index: 1;
                    box-sizing: border-box;
                    width: 351px;
                   background: #FFFFFF;
                    box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.1), 0px 4px 6px -4px rgba(16, 24, 40, 0.1);
                    border-radius: 12px;
                    padding:29px 24px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    .toplog {
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                            letter-spacing: -0.02em;
                             font-weight: 800;
                        font-family: MuliBold;
                        h1 {
                            text-align: center;
                            letter-spacing: -0.02em;
                            color: #191919;
                            font-size: 36px;
                            line-height: 40px;
                            font-weight: 800;
                        }
                        .subTitle {
                            font-size: 24px;
                            letter-spacing: -0.02em;
                        }
                        .subBreif{
                          font-size: 14px;
                          display: block;
                          margin-top: 10px;
                          color: #374151;
                           font-weight: 400;
                        font-family: Muli;
                        }
                    }
                    button {
                        margin-top: 12px;
                        width: 100%;
                        height: 48px;
                        border: none;
                        background: linear-gradient(94.75deg, #FF6F1E 46.16%, #F9A849 91.27%);
                        border-radius: 25px;
                        font-family: 'MuliBold';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 18px;
                        line-height: 28px;
                        text-align: center;
                        font-feature-settings: 'salt' on;
                        color: #FFFFFF;
                    }
                }
            }

        // .bgred {
        //     height: 200px;
        //     position: absolute;
        //     bottom: 0;
        //     left: 0;
        //     right: 0;
        //     background: url('../assets/img/Vector.png');
        // }
    }
    .bodypink {
        background: #f7f5fa;
        padding: 60px 0 0 0;
        width:100vw;
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        // .classover {
        //     margin: 0 auto;
        //     position: absolute;
        //     top: -15px;
            /* position: inherit; */

            /*  > div {
                width: 70%;
                height: 56.08px;
                position: absolute;
                top: 72px;
                left: calc(50vw - 35%);
                right: 96px;
            }
            img:first-child {
                position: absolute;
                top: 100px;
                left: 7%;
                width: 83px;
                height: 39px;
            }
            img:last-child {
                position: absolute;
                top: 100px;
                right: 6%;
                width: 83px;
                height: 39px;
            } */
        // }
        // .title {
        //     margin-top: 60px;
        //     width: 70%;
        //     height: 72px;
        //     /* background: #ff5979; */
        //     /* border-radius: 4px; */
        //     /*  font-weight: 600;
        //     font-size: 20px;
        //     display: flex;
        //     justify-content: center;
        //     color: white;
        //     align-items: center;*/
        //     text-align: center;

        //     margin-left: 15%;
        //     img {
        //         width: 100%;
        //     }
        // }
        .four {
            width: 350px;
            margin: 0 auto;
            border: 1px solid #FF5979;
            box-sizing: border-box;
            border-radius: 16px;
            height: 982px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            position: relative;
            margin-top:50px;
            img{
              position: absolute;
              top:-48px;
              left:50%;
              margin-left:-125px;
              z-index:21;
              width: 250px;
              height: 67.85px;
            }
            .title-1{
              position: absolute;
              top:-40px;
              left:50%;
              margin-left:-70px;
                z-index:22;
                font-size: 20px;
                color: #FFFFFF;
                font-weight: 700;
                font-family:MuliBold ;

            }
             .flexsum{
                margin-top: 80px;
            }
            .flex-line{

                    justify-content: space-around;
                    align-items: center;
                    width:100%;
                    // text-align: center;
                    flex-direction: column;
                    justify-content: start;
                    align-items: flex-start;
                    span {
                        display: block;
                        font-style: normal;
                        font-size: 22px;
                        text-align: center;
                        margin: 0 auto;
                    }
                    p{
                        margin: 0px;
                    }
                    span:first-child {
                        color: #FF5979;
                        margin-bottom:30px;
                        width: 334px;
                        font-weight: 700;
                        font-family: MuliBold;
                        font-size: 27px;
                        line-height: 45px;
                    }
                    span:last-child {
                        font-size: 20px;
                        line-height: 36px;
                        margin-bottom: 80px;
                        width: 334px;
                        font-weight: 400;
                    }

            }


            > div:nth-child(odd) {
            }
            // margin: 47px 4%;
            // border: 1px solid #ff5979;
            // box-sizing: border-box;
            // border-radius: 16px;
            // height: 240px;
            // display: flex;
            // flex-wrap: wrap;

            // /*  padding: 0 25px; */
            // justify-content: space-around;
            // > div {
            //     width: 40%;
            //     height: 50px;
            //     display: flex;
            //     flex-direction: column;

            //     text-align: start;
            //     span {
            //         font-style: normal;
            //         font-size: 18px;
            //     }
            //     span:first-child {
            //         color: #ff5979;
            //     }
            //     span:last-child {
            //     }
            // }
            // > div:nth-child(1),
            // > div:nth-child(2) {
            //     margin-top: 58px;
            // }
        }
        .pinkTwo {
          width:360px;
            .two_tit {
                display: flex;
                flex-direction: column;
                align-items: center;
                    text-align: center;
                span:nth-child(1) {
                    font-size: 25px;
                    color: black;
                    margin-bottom:45px;
                      font-family: MuliBold;
                    font-weight: 700;

                }
                span:nth-child(2) {
                    font-size: 16px;
                    color: #374151;
                    line-height: 28px;
                    font-weight: 400;

                }
            }
            .piclist{
              display: none;
            }
            .tabs {
              display: block;
                /* height: 800px; */
                padding-top: 75px;
                /deep/ .el-carousel__arrow{
                  display: none;
                }
                /deep/ .el-carousel__indicator--horizontal {
                  .el-carousel__button{
                    width: 27px;
                    height: 3px;
                    background: #C4C4C4;
                    border-radius: 37px;
                  }
                  &.is-active .el-carousel__button{

                    background: #E83155;
                  }
                }
                .tab1 {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;

                    > div {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;
                        position: relative;
                        margin: 0px 20px;
                        margin-bottom: 25px;

                        span {
                            margin-top: 15px;
                            font-size: 16px;
                            font-family: Muli;
                            font-weight: 400;
                        }
                        .oneimg1{
                            width: 70px;
                        }
                    }
                    div:last-child {
                    }
                }
            }
        }
    }
    .bodyred {
      position: relative;
      padding-top:73px;
      .img1{
        width: 117.5px;
        height: 135px;
        position: absolute;
        top:0;
        left:0;
        z-index:10;
      }
      .img2{
        width: 68px;
        height: 90.5px;
        position: absolute;
        top:0;
        left:0;
        z-index:11;
      }
      .img3{
        display: none;
      }
        // .bgCircleRed {
        //     width: 80vw;
        //     height: 80vw;
        //     border-radius: 50%;
        //     position: absolute;
        //     background: #e83155;
        //     box-shadow: 0px 4px 80px rgba(6, 41, 70, 0.25);
        //     top: -40vw;
        //     left: -40vw;
        //     display: flex;
        //     justify-content: center;
        //     align-items: center;

        //     > div {
        //         width: 50vw;
        //         height: 50vw;
        //         border-radius: 50%;

        //         background: #e83155;
        //         box-shadow: 0px 4px 80px rgba(6, 41, 70, 0.25);
        //     }
        // }
        /* .bgCircleRed {
            position: absolute;
            top: 0;
            left: 0;
            width: 190px;
            height: 245px;
            background: url('../assets/img/Ellipsemobile2.png') no-repeat;

            > div {
                position: absolute;
                top: 0;
                left: 0;
                width: 130px;
                height: 181px;

                background: url('../assets/img/Ellipsemobile.png') no-repeat;
            }
        } */

        .youshiBox{
          width:360px;
            height: 100%;
            z-index:13;
            position: relative;
            .title-2{
              p{
                position: absolute;
                top:-10px;
                left:50%;
                margin-left:-75px;
                  z-index:22;
                  font-size: 20px;
                  color: #000000;
                  font-weight: 700;
                font-family: MuliBold;
                width: 150px;
                text-align: center;
              }

                img{
                  position: absolute;
                    // top:-48px;
                    left:50%;
                    margin-left:-125px;
                    z-index:21;
                // z-index:21;
                    width: 250px;
                    height: 67.85px;
                }
                // .title-1{
                //   position: absolute;
                //   top:-45px;
                //   left:50%;
                //   margin-left:-111px;
                //     z-index:22;
                //     font-size: 32px;
                //     color: #FFFFFF;
                // }
            }

            .THRbox {
              width:100%;
                margin-top: 134px;
                .whitebox {
                  width:100%;
                    height: 112px;
                    flex:1;
                    margin-right:32px;
                    background: #FFFFFF;
                    text-align: center;
                    /* Drop shadow/Small */

                    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px -1px rgba(16, 24, 40, 0.1);
                    border-radius: 6px;


                    // width: 30vw;
                    /*  width: 384px; */
                    background-color: #fff;
                    border-radius: 6px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: center;
                    margin-bottom:28px;
                    span:first-child {
                        color: #ff5979;
                        font-size: 28px;
                        font-family: MuliBold;
                       font-weight: 700;
                    }
                    span {
                        font-size: 16px;
                        color: #6B7280;
                        font-weight: 400;

                    }
                }
            }
        }
        .jiangpai {
            display: none;
        }
        .iphone {
            width: 542.32px;
            height: 276.74px;
            position: absolute;
            background: #ffffff;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
            bottom: 260px;
            left: -80px;
            border-radius: 47px;
            transform: rotate(-10.16deg);
            z-index: 2;
            display: block;

            img {
                width: 518.92px;
                position: absolute;
                left: 13px;
                top: -20px;
                transform: rotate(10.16deg);
            }
        }

        .guide {
            position: absolute;
            /*  background: url('../assets/img/Groupguird.png') no-repeat; */
            bottom: 0;
            z-index: 13;
            right: 0;
            width: 226.55px;
            // height: 345.92px;
        }
        // .guideApp {
        //     position: absolute;
        //     background: url('../assets/img/GroupApp.png') no-repeat;
        //     bottom: 0;
        //     z-index: 1;
        //     right: 0;
        //     width: 191px;
        //     height: 289px;
        // }
        .appCircleRIG {
          display: block;
            position: absolute;
            bottom: 0;
            right: 0;
            width: 369px;
            height: 337px;
            background: url('../assets/img/appcircle.png');
            > div {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 271px;
                height: 234px;
                background: url('../assets/img/appcircle2.png');
            }
        }
    }
    .bgWhite {
        background: #fff;
        text-align: center;
        .whiteBg {
          width:360px;
            padding: 160px 0 67px 0;
            font-size: 32px;
            position: relative;
            >img{
              margin-top:30px;
            }

            .cerebrumAPP {
                z-index: 10;
                position: absolute;
                background: url('../assets/img/Framecere.png') no-repeat;
                top: -55px;
                // margin-bottom: -62px;
                right: 50%;
                margin-right: -63px;
                width: 126px;
                height: 123px;
            }
        }


				.video_box{
					width:100%;
						margin-top:72px;
					.video_info{
						height:186px;
						margin-right:0;
						margin-bottom:56px;
					}
        }
        .swiperfor {
            margin-top: 80px;
            text-align: center;
             font-weight: 700;
            font-family: MuliBold;
            > div:nth-child(1) {
                font-size: 14px;
                color: #ff5979;
                margin-bottom:15px;

            }
            > div:nth-child(2) {
                font-size: 32px;
                color: #000;
                margin-bottom:80px;
            }
        }
    }
    // .star-left {
    //     width: 90%;
    // }
    // .star-item {
    //     border: 1px solid #f1f1f1;
    //     border-radius: 21px;
    //     padding: 25px;
    //     box-sizing: border-box;
    // }
    // .arrow-left,
    // .arrow-right {
    //     display: none;

    // }

    .star-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .star-left {
            width:320px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 30px;
            font-size: 12px;

            label {
                font-size: 21.654px;
                line-height: 100%;

                text-align: center;

                color: #000000;
            }

            .star-img-big {
                width: 190.07px;
                height: 39.7px;
            }
        }
         .start-content{
             display: flex;
            flex-direction: column;
            justify-content: center;
            //  margin-left:60px;
             .info-feed{

                box-shadow: 12px 8px 33px rgba(0, 0, 0, 8%);
                height: 179px;
                width: 241px;
                padding: 19px 13px;
                margin-bottom:40px;
                &:nth-child(3){
                }
                h6 {
                    color: #000;
                    // display: block;
                    // width: 183px;
                    font-size: 20px;
                    z-index: 100040;
                    line-height: 1.1;
                    letter-spacing: 0;
                    text-align: left;
                    text-align-last: left;
                    font-style: normal;
                    display: block;
                    margin: 0 11px;
                    margin-bottom: 13px;
                    font-family: "times new roman";
                    font-weight: bold;
                }
                p {
                    color: #000;
                    display: block;
                    // width: 177px;
                    font-size: 14px;
                    line-height: 1.4;
                    letter-spacing: 0;
                    font-style: normal;
                    text-align: left;
                    text-align-last: left;
                    margin: 0 8px;
                    font-family: "open sans";
                }
                img {
                    width: 190.07px;
                    height: 39.7px;
                    margin-bottom: 6px;
                }
             }
         }

    }
    .btn_lq {
        width: 100%;
        height: 47px;
        border-radius: 25px;
        background: #ff5979;
        color: white;
        margin: 70px auto 0;
        font-size: 18px;
        justify-content: center;
        align-items: center;
        display: flex;
    }
    .imgthree{
        display: none;
        }
    footer {
        background: #FFFFFF;
        // height: 1429px;
        text-align: center;
        position: relative;
        .foottop{
            margin:38px auto 55px;
            // padding:0 40px;
             width: 100%;
             box-sizing: border-box;
            display: flex;
            flex-direction:column;
            .foottopitem{
                width: 100%;
                // height: 294px;
                display: flex;
            flex-direction:column;
               .itemdiv{
                  box-shadow: 0px 6.66332px 26.6533px #F4F2F2;
                  width: 347px;
                  margin: 0 auto;
                  display: flex;
                flex-direction:column;
                  padding: 30px 0 20px;
                  box-sizing: content-box;
                  background: #FFFFFF;
                  border-radius: 10px;
                  .itemright{
                    //   width: calc(100% - 320px);
                      padding: 16px 21px  0;
                      ul{
                          margin: 0;
                          padding-left: 30px;
                          li{
                              font-family: 'Muli';
                                font-style: normal;
                                font-weight: 400;
                                font-size: 24px;
                                line-height: 36px;
                                font-feature-settings: 'salt' on;
                                color: #000000;
                                opacity: 0.85;
                                text-align: left;
                          }
                      }
                  }
                  .itemleft{
                      width: 262px;
                      margin: 0 auto;
                      border-bottom: 1px solid rgb(229, 229, 229);
                      p{
                          margin: 9px 0 6px;
                          font-family: 'MuliBold';
                            font-style: normal;
                            font-weight: 700;
                            font-size: 34px;
                            // line-height: 24px;
                            text-align: center;
                            font-feature-settings: 'salt' on;
                            color: #111827;
                      }
                      span{
                          font-family: 'MuliBold';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 24px;
                        line-height: 28px;
                        text-align: center;
                        font-feature-settings: 'salt' on;
                        color: #0085F2;
                        display: block;
                        width: 260px;
                        margin: 0 auto 32px;
                        p{
                            font-family: 'MuliBold';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 24px;
                        line-height: 28px;
                        text-align: center;
                        font-feature-settings: 'salt' on;
                        color: #0085F2;
                        display: block;
                        margin: 0;
                        }
                      }
                  }
                }
                .itemdiv+.itemdiv{
                    margin-top: 32px;
                }

            }
            .foottopitem+.foottopitem{
                margin-top:39px;
            }
        }
        .footbottom{
            width: 356px;
            margin: 0 auto 69px;
        }
    }
    .moliepost {
        position: inherit !important;
    }
    .disflex{
        display: block;
    }


    //
    footer .foottop .foottopitem .itemdiv .li6{
        // width: 290px;
        padding: 16px 12px 0;
    }
    footer .foottop .foottopitem .itemdiv .li5{
        // width: 290px;
        padding: 16px 16px 0  11px;
         li:nth-child(1){
            width: 285px;
        }
        li:nth-child(3){
            width: 285px;
        }
    }
    footer .foottop .foottopitem .itemdiv .li4{
        // width: 290px;
        padding: 16px 11px 0  11px;
    }
    footer .foottop .foottopitem .itemdiv .li3{
       li:nth-child(1){
            width: 260px;
        }
        // padding: 16px 11px 0  11px;
    }

    .imglogobox{
        text-align: center;
        margin: 10px 0 0;
        height: 46px;
        img{
            width: 128.84px;
            // height: 34.61px;
        }
    }
    .imgbox{
        margin: 30px 0 0;
        text-align: center;
        .title{
            margin: 0;
            display: flex;
            justify-content: center;
        }
        .imggr1{
           width: 182px;
            // height: 93px;
            display: block;
        }
        .contenrbox{
            width: 365px;
            display: flex;
            flex-wrap:wrap;
            margin: 28px auto 0;
            align-items: center;
        }

         .imggr2,.imggr3,.imggr4,.imggr5{
            width: 182px;
            display: block;

        }
        // .imggr2{
        //     height: 37px;
        // }
        .imggr5{
            width: 230px;
        }
    }

}
/deep/ .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: inherit;
}
/* el-carousel__indicator--horizontal  */
a {
    text-decoration: none;
    color: black;
}
.lastitem {
    margin: 0px;
    margin-right: calc(50vw - 70.5px - 15px);
}

section{
    .right{
        .forms_submit{
            /deep/.el-form{
                .el-form-item .el-form-item__content .el-input__inner:focus-within {
                    border:1px solid hsl(0, 0%, 0%);
                }
            }
        }
    }
}
#mien{
    font-weight: 700;
    font-family: MuliBold;
}
/deep/.el-select{
    .el-input__inner{
         background-image: -webkit-linear-gradient(left, rgba(0, 0, 0,1), rgba(0, 0, 0, 0.2));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .el-input__suffix{
        background: #FFFFFF;
        height: 40px;
        top:3px;
    }

}
/deep/ section .right .forms_submit .el-form .el-form-item .el-form-item__content .el-select .el-input__inner{

font-style: normal;
font-weight: 500;
font-size: 14px;
color: #111827;

}

</style>>



// WEBPACK FOOTER //
// src/components/Index.vue